import { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../states/reducers';
import { fetchUserProfile } from '../../states/action_creators/profile.action_creator';

export const useFetchUserProfile = () => {
  const { userProfile, fetching } = useSelector((state: RootState) => state.userProfile)
  const dispatch = useDispatch()

  const handleFetchUserProfile = async () => {
    dispatch(fetchUserProfile())
  }

  useEffect(() => {
    if (!userProfile) {
      handleFetchUserProfile()
    }
  }, [userProfile])

  return { fetching, userProfile, handleFetchUserProfile }
}
